<app-auth-layout [loading]="loading">
    <div class="row mx-0 my-1">
        <div class="col-6">
            <h5
                class="font-bold text-center uppercase"
              >
              Guidelines For Filling The Application Form
              </h5>
              <ol class="ordered-list">
                <li>Provide the details in the fields below to obtain a Payment Voucher.</li>
                <li>Print the payment voucher and&nbsp; make payment online or proceed to any branch of the below banks to make payment: 
                    <ol>
                    <li><strong>WEMA Bank Plc (Unilag Branch)</strong></li>
                    </ol>
                 </li>
                <li>Pay the non-refundable sum of <strong>N10,000.00 (Ten Thousand Naira)</strong> for  the Application Form. </li>
                <li>After payment, return to the&nbsp; Portal,&nbsp; then click the "Continue Application" link, login with Payment Reference Number and provided surname (in lowercase) as password.</li>
                <li>Complete the application by filling all the required fields and&nbsp; upload digital passport photograph (jpeg format) which should not be more than 30 kb in size and must be in white background.  The acceptable dimension is width: 275 pixels or 35mm, height: 314 pixels or 40mm. click continue to proceed to preview page</li> 
                <li>Preview your application to ensure the&nbsp; information provided are accurate Click "SUBMIT FORM" after which you can no longer edit the application.  After submission, applicants will be required to print the completed Application Form . Printed copies of the Application Form should be submitted to the school with the photocopy of child's birth certificate within 2 weeks of purchase of form.</li>
                </ol>        
        </div>
        <div class="col-6">
            <form (ngSubmit)="saveApplication()" class="flex flex-col h-full">
              <h1
                class="font-bold py- text-center text-lg pb-4 uppercase md:text-xl md:pb-8 lg:text-2xl"
              >
                Apply Online
              </h1>
          
              <app-notification-alert [data]="notification"></app-notification-alert>
        
              <div class="py-1">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="Surname"
                >
                  Surname *
                </label>
                <input
                  [(ngModel)]="payload.Surname"
                  class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                  id="Surname"
                  type="text"
                  required
                  placeholder="Surname"
                />
              </div>
        
              <div class="py-1">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="FirstName"
                >
                First Name *
                </label>
                <input
                  [(ngModel)]="payload.FirstName"
                  class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                  id="FirstName"
                  type="text"
                  required
                  placeholder="First Name"
                />
              </div>
        
              <div class="py-1">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="MiddleName"
                >
                Middle Name *
                </label>
                <input
                  [(ngModel)]="payload.MiddleName"
                  class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                  id="MiddleName"
                  type="text"
                  required
                  placeholder="Middle Name"
                />
              </div>
        
              <div class="py-1">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="DOB"
                >
                Date of Birth *
                </label>
                <input
                  [(ngModel)]="payload.DOB"
                  class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                  id="DOB"
                  type="date"
                  required
                  placeholder="Date of Birth"
                />
              </div>
        
              <div class="py-1">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="ApplicationType"
                >
                Application Type *
                </label>
                <select
                  [(ngModel)]="payload.ApplicationType"
                  class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                  id="ApplicationType"
                  type="text"
                  required>
                    <option disabled value="">Select application type</option>
                    <option *ngFor="let applicationType of applicationTypes" [value]="applicationType.Id">
                        {{ applicationType.Name }}
                      </option>

                  </select>
              </div>
        
              <div class="py-1">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="ContactPhone"
                >
                Contact Phone *
                </label>
                <input
                  [(ngModel)]="payload.ContactPhone"
                  class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                  id="ContactPhone"
                  type="tel"
                  required
                  placeholder="Contact Phone"
                />
              </div>
        
              <div class="py-1">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="ContactEmail"
                >
                Contact Email *
                </label>
                <input
                  [(ngModel)]="payload.ContactEmail"
                  class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                  id="ContactEmail"
                  type="email"
                  required
                  placeholder="Contact Email"
                />
              </div>

              <div *ngIf="validationError" class="text-xs text-error-dark italic">
                Please fill all required fields
              </div>
              <div class="py-1">
                <app-button-primary type="submit" [disabled]="loading" class="w-full">
                  Submit
                </app-button-primary>
              </div>
        
        <!--   
              <div class="py-1">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="email"
                >
                  Matric/Application number
                </label>
                <input
                  [(ngModel)]="payload.StudentNo"
                  class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                  id="email"
                  type="text"
                  required
                  placeholder="Matric/Application number"
                />
                <div *ngIf="errors.StudentNo" class="text-xs text-error-dark italic">
                  Please enter your Matric or Application number
                </div>
              </div>
          
              <div class="pb-4">
                <label
                  class="font-bold text-grey-darker text-sm mb-2 block"
                  htmlFor="password"
                >
                  Password
                </label>
                <div class="relative mb-3">
                  <input
                    [(ngModel)]="payload.Password"
                    class="border rounded bg-gray-50 text-sm w-full py-2 px-3 pr-10 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
                    placeholder="******************"
                    id="password"
                    [type]="showPassword ? 'text' : 'password'"
                    required
                  />
                  <button type="button" (click)="showPassword = !showPassword"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors">
                    <svg *ngIf="!showPassword" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                    </svg>
                    <svg *ngIf="showPassword" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                    </svg>
                  </button>
                </div>
                <div *ngIf="errors.Password" class="text-xs text-red-500 italic">
                  Please enter a password.
                </div>
              </div>
          
              <div class="text-right">
                <a
                  routerLink="/forgot-password"
                  class="font-bold text-sm text-primary inline-block align-baseline hover:text-primary-dark hover:underline"
                >
                  Forgot Password?
                </a>
              </div>
          
              <div class="py-1">
                <app-button-primary type="submit" [disabled]="loading" class="w-full">
                  Sign In
                </app-button-primary>
              </div> -->
            </form>

        </div>
    </div>
  </app-auth-layout>
  